<template>
  <Loading v-if="loading" />
  <div class="settings">
    <div class="settings__header">
      <Link :title="$t('backToCustomersFeedback')" @back-to="backTo" />
      <Title :title="$t('settings')" />
    </div>
    <Tabs :tabs="tabs" @select-tab="setActiveTab" />
    <router-view></router-view>
  </div>
</template>

<script lang="ts">
import { Options, Vue } from 'vue-class-component';
import { mapActions, mapState } from 'vuex';

import Loading from '@/views/Loading.vue';
import router from '@/router';

import { tabs } from './configs';

@Options({
  name: 'SettingsCustomersFeedback',
  components: {
    Loading
  },
  data() {
    return {
      loading: false,
      tabs
    };
  },
  computed: {
    ...mapState('pharmacy', ['pharmacy']),
    ...mapState('account', ['user'])
  },
  created() {
    if (this.user) {
      this.setActiveTab('General');
    }
  },
  methods: {
    ...mapActions('pharmacy', ['getPharmacy']),
    async setActiveTab(tabValue: string) {
      this.loading = true;

      const id = this.user?.pharmacyId;

      router.push({ name: tabValue, params: { id } });
      this.loading = false;
    },
    backTo() {
      router.push({ name: 'CustomersFeedback' });
    }
  }
})
export default class SettingsCustomersFeedback extends Vue {}
</script>

<style lang="scss" scoped>
.settings {
  overflow-y: clip;
  .settings__header {
    padding: 24px;
    padding-bottom: 32px;
    .title {
      margin-top: 27px;
    }
  }
}
</style>
